import * as types from '../actions/actionTypes.js';
import initialState from "./initialState.js";

export function costObjectsReducer(
  state = initialState.costObjects, action
) {
  switch(action.type){
      case types.FETCH_COST_OBJECTS_SUCCESS:
          return action.costObjects;
      default:
          return state;
  }
}

export function relevantJobsReducer(
  state = initialState.relevantJobs, action
) {
  switch (action.type) {
      case types.FETCH_RELEVANT_JOBS_SUCCESS:
          return action.relevantJobs;
      default:
          return state;
  }
}

export function relevantJobsForCostObjectReducer(
  state = initialState.relevantJobsForCostObject, action
) {
  switch (action.type) {
      case types.FETCH_RELEVANT_JOBS_FOR_COST_OBJECT_SUCCESS:
          return action.relevantJobsForCostObject;
      default:
          return state;
  }
}

export function relatedBranchesReducer(
  state = initialState.relatedBranches, action
) {
  switch (action.type) {
      case types.FETCH_RELATED_BRANCHES_SUCCESS:
          return action.relatedBranches;
      default:
          return state;
  }
}

export function groupsByBranchAndResourceReducer(
  state = initialState.groupsByBranchAndResource, action
) {
  switch (action.type) {
      case types.FETCH_GROUPS_BY_BRANCH_AND_RESOURCE_SUCCESS:
          return action.groupsByBranchAndResource;
      default:
          return state;
  }
}

export function servicesByDateReducer(
  state = initialState.servicesByDate, action
) {
  switch (action.type) {
      case types.FETCH_SERVICES_BY_DATE_SUCCESS:
          return action.servicesByDate;
      default:
          return state;
  }
}

export function activityTypesReducer(
  state = initialState.activityTypes, action
) {
  switch (action.type) {
      case types.FETCH_ACTIVITY_TYPES_SUCCESS:
          return action.activityTypes;
      default:
          return state;
  }
}

export function serviceSalaryLevelReducer(
  state = initialState.serviceSalaryLevel, action
) {
  switch (action.type) {
    case types.FETCH_SERVICE_SALARY_LEVEL_SUCCESS:
        return action.serviceSalaryLevel;
    default:
        return state;
  }
}

export function servicePrimaryRateReducer(
  state = initialState.servicePrimaryRate, action
) {
  switch (action.type) {
    case types.FETCH_SERVICE_PRIMARY_RATE_SUCCESS:
        return action.servicePrimaryRate;
    default:
        return state;
  }
}

export function serviceJobSalariesReducer(
  state = initialState.serviceJobSalaries, action
) {
  switch (action.type) {
    case types.FETCH_JOB_SALARIES_BY_SERVICE_SUCCESS:
        return action.serviceJobSalaries;
    default:
        return state;
  }
}

export function logJobStartRecordReducer(
  state = initialState.logJobStartRecord, action
) {
  switch (action.type) {
    case types.LOG_JOB_START_SUCCESS:
        return action.logJobStartRecord;
    default:
        return state;
  }
}

export function logJobFinishRecordReducer(
  state = initialState.logJobFinishRecord, action
) {
  switch (action.type) {
    case types.LOG_JOB_FINISH_SUCESS:
        return action.logJobFinishRecord;
    default:
        return state;
  }
}

export function jobReducer(
  state = initialState.job, action
) {
  switch (action.type) {
    case types.ADD_JOB_SUCCESS:
        return action.job;
    case types.EDIT_JOB_SUCCESS:
        return action.job
    case types.REMOVE_JOB_SUCCESS:
        return action.response;
    case types.FETCH_JOB_SUCCESS:
        return action.job;
    default:
        return state;
  }
}

export function jobElementReducer(
  state = initialState.jobElement, action
) {
  switch (action.type) {
    case types.ADD_JOB_ELEMENT_SUCCESS:
        return action.jobElement;
    case types.EDIT_JOB_ELEMENT_SUCCESS:
        return action.jobElement;
    case types.REMOVE_JOB_ELEMENT_SUCCESS:
        return action.response;
    case types.FETCH_JOB_ELEMENT_SUCCESS:
        return action.jobElement;
    default:
        return state;
  }
}

export function validateEmptyJobReducer(
  state = initialState.validateEmptyJob, action
) {
  switch (action.type) {
    case types.FETCH_VALIDATE_EMPTY_JOB_SUCCESS:
        return action.response;
    default:
        return state;
  }
}


export function costObjectReducer(
  state = initialState.costObject, action
) {
  switch (action.type) {
    case types.FETCH_COST_OBJECT_SUCCESS:
        return action.costObject;
    default:
        return state;
  }
}

export function jobElementsWithDetailsReducer(
  state = initialState.jobElementsWithDetails, action
) {
  switch (action.type) {
    case types.FETCH_JOB_ELEMENTS_WITH_DETAILS_SUCCESS:
        return action.jobElementsWithDetails;
    default:
        return state;
  }
}

export function serviceReducer(
  state = initialState.service, action
) {
  switch (action.type) {
    case types.FETCH_SERVICE_SUCCESS:
        return action.service;
    default:
        return state;
  }
}

export function groupsByBranchInCompanyReducer(
  state = initialState.groupsByBranchInCompany, action
) {
  switch (action.type) {
    case types.FETCH_GROUPS_BY_BRANCH_IN_COMPANY_SUCCESS:
        return action.groupsByBranchInCompany;
    default:
        return state;
  }
}

export function assignmentServicesByGroupReducer(
  state = initialState.assignmentServicesByGroup, action
) {
  switch (action.type) {
    case types.FETCH_ASSIGNMENT_SERVICES_BY_GROUP_SUCCESS:
        return action.assignmentServicesByGroup;
    default:
        return state;
  }
}

export function servicesByGroupReducer(
  state = initialState.servicesByGroup, action
) {
  switch (action.type) {
    case types.FETCH_SERVICES_BY_GROUP_SUCCESS:
        return action.servicesByGroup;
    default:
        return state;
  }
}

export function jobElementsReducer(
  state = initialState.jobElements, action
) {
  switch(action.type) {
    case types.FETCH_JOB_ELEMENTS_SUCCESS:
      return action.jobElements;
    default:
      return state;
  }
}

export function approvedJobElementsReducer(
  state = initialState.approvedJobElements, action
) {
  switch(action.type) {
    case types.FETCH_APPROVED_JOB_ELEMENTS_SUCCESS:
      return action.approvedJobElements;
    default:
      return state;
  }
}





